import { HeadingText, ParagraphText } from '@leagueplatform/genesis-core';
import {
  defaultHTMLTagOptions,
  HTMLTagOptions,
  isAbsoluteUrl,
} from '@leagueplatform/web-common';
import { useLocation } from 'react-router-dom';
import { MASONRY_RICH_TEXT_EXTERNAL_LINK_NEW_TAB_ROUTES } from 'common/app-managed-routes';

export const getHtmlToReactOptionsOverride = (
  shouldOpenExternalLinksInNewTab: boolean,
): HTMLTagOptions => ({
  h1: {
    component: (props) => <HeadingText {...props} />,
    props: {
      css: {
        marginBottom: '$one',
      },
    },
  },
  a: {
    component: ({ href, children, ...props }) => {
      const isExternal = isAbsoluteUrl(href);
      return (
        <a
          href={href}
          {...props}
          {...(shouldOpenExternalLinksInNewTab &&
            isExternal && {
              target: '_blank',
              rel: 'noopener noreferrer',
            })}
        >
          {children}
        </a>
      );
    },
  },
});

export const MasonryRichTextRenderer = ({ text }: { text: string }) => {
  const { pathname } = useLocation();
  const shouldOpenExternalLinksInNewTab =
    MASONRY_RICH_TEXT_EXTERNAL_LINK_NEW_TAB_ROUTES.includes(pathname);

  return (
    <ParagraphText
      htmlStringOptions={{
        ...defaultHTMLTagOptions,
        ...getHtmlToReactOptionsOverride(shouldOpenExternalLinksInNewTab),
      }}
    >
      {text}
    </ParagraphText>
  );
};
